module.exports = __webpack_public_path__ + "static/media/surfboardsHome.f3fde8ee.jpg";